import { render } from "./LoadChat.vue?vue&type=template&id=22dc0e64"
import script from "./LoadChat.vue?vue&type=script&lang=js"
export * from "./LoadChat.vue?vue&type=script&lang=js"

import "./LoadChat.vue?vue&type=style&index=0&id=22dc0e64&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__